// extracted by mini-css-extract-plugin
export default {"TextArea":"xfucAgUf","TextAreaPlaceholder":"W8YfesES","PlaceholderContent":"qihFHU8t"};